import React from "react";
import { Month } from "./Month";
import {MonthSimple} from "./MonthSimple";

export const Months = props => {
  const months = [];

  if(props.view === "year" && !props.canCreateItems) {
    for (let month = 1; month < 2; month++) {
      months.push(<MonthSimple key={month} month={month} {...props} />);
    }
  } else {
    for (let month = 1; month < 25; month++) {
      months.push(<Month key={month} month={month} {...props} />);
    }
  }

  return months;
};
